module.exports = __webpack_public_path__ + "static/media/magnifying-glass-location-solid.8a477ca2.svg";